/* eslint-disable indent */
import { useIntl } from 'react-intl';

function useLocationName(id, controlledVocab = {}) {
  const intl = useIntl();
  const locations = controlledVocab.locations;

  const location = locations?.find((loc) => loc.id === id);

  return {
    locationName: !id
      ? ''
      : intl.formatMessage({
          id: `ui-tenant-settings.locations.name.${location.name}`,
          defaultMessage: location.name,
        }),
    locationCode: !id ? '' : location.code,
  };
}

useLocationName.propTypes = {};

export default useLocationName;
